// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

// Import your existing views/components
import FirebaseUserManager from "@/components/FirebaseUserManager.vue";
import LoginView from '@/views/LoginView.vue';
import CategoriesView from '@/views/CategoriesView.vue';
import CatalogView from '@/views/CatalogView.vue';
import ProductView from '@/views/ProductView.vue';

// 1) Import the new coverage component
import AttributeCoverage from '@/views/AttributeCoverage.vue'; // or wherever you placed it

// Create a promise to track when auth is ready
const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(
      getAuth(),
      (user) => {
        removeListener();
        resolve(user);
      },
      reject
    );
  });
};

// Simple route guard that requires auth
const requireAuth = async (to, from, next) => {
  const user = await getCurrentUser();
  if (!user) {
    next({ name: 'login' });
  } else {
    next();
  }
};

const routes = [
  {
    path: '/',
    redirect: { name: 'categories' }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/categories',
    name: 'categories',
    component: CategoriesView,
    beforeEnter: requireAuth
  },
  {
    path: '/catalog',
    name: 'catalog',
    component: CatalogView,
    beforeEnter: requireAuth
  },
  {
    path: '/product/:id',
    name: 'product',
    component: ProductView,
    props: true,
    beforeEnter: requireAuth
  },
  {
    path: '/admin',
    component: FirebaseUserManager,
    meta: { requiresAuth: true, requiresAdmin: true }
  },

  // 2) Add your new "attribute coverage" route
  {
    path: '/attribute-coverage',
    name: 'attributeCoverage',
    component: AttributeCoverage,
    beforeEnter: requireAuth, // or a special admin guard if you prefer
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
